'use client';
import { useEffect, useState } from 'react';

const CARD_WIDTH = 348;
const CARD_MARGIN = 24;
const MIN_CARDS = 1;
const MAX_CARDS = 3.5;

export function useCardCount() {
  const [cardCount, setCardCount] = useState(MIN_CARDS);

  useEffect(() => {
    function calculateCards() {
      if (typeof window === 'undefined') return;

      const screenWidth = window.innerWidth;
      const cardWithSpacing = CARD_WIDTH + CARD_MARGIN;
      const raw = (screenWidth + CARD_MARGIN) / cardWithSpacing;
      const possible = Math.floor(raw * 2) / 2;
      const count = Math.max(MIN_CARDS, Math.min(MAX_CARDS, possible));
      setCardCount(count);
    }

    calculateCards();
    window.addEventListener('resize', calculateCards);
    return () => window.removeEventListener('resize', calculateCards);
  }, []);

  return cardCount;
}
